export const colorPickerStyle = {
	content: {
		width: '100%',
		padding: '10px 12px',
		border: '1px solid var(--neutral-200)',
		borderRadius: '8px',
		height: '44px',
		display: 'flex',

		'&:hover': {
			border: '1px solid var(--neutral-300)',
		},

		'& > div': {
			alignItems: 'center',
		},

		'.ColorPicker-MuiButtonBase-root': {
			borderRadius: '50%',
			width: '21px',
			minWidth: '21px',
			height: '21px',
			margin: '2px',
			marginRight: '8px',

			'& span > div': {
				borderRadius: '50%',
				border: '1px solid var(--neutral-200)',
			},
		},

		'.ColorPicker-MuiFormControl-root': {
			maxWidth: '400px',

			'& .ColorPicker-MuiInputBase-root': {
				fontSize: '16px',

				'&:before, &:after': {
					display: 'none',
				},
			},
		},
	},

	disabled: {
		border: '1px solid var(--neutral-100)',

		'& .ColorPicker-MuiInputBase-root': {
			color: 'var(--neutral-200)',
		},
		'&:hover': {
			border: '1px solid var(--neutral-100)',
		},
	},

	error: {
		border: '1px solid var(--error-500)',

		'& .ColorPicker-MuiInputBase-root': {
			color: 'var(--error-500)',
		},

		'&:hover': {
			border: '1px solid var(--error-500)',
		},
	},
};
